"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return _default;
    }
});
const _XcPluginHooks = /*#__PURE__*/ _interop_require_default(require("./XcPluginHooks"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let XcPlugin = class XcPlugin extends _XcPluginHooks.default {
    constructor(app, config){
        super();
        this.app = app;
        this.config = config;
    }
};
const _default = XcPlugin;
